interface ExtractedContact {
  name: string;
  phone?: string;
  email?: string;
  role?: string;
}

const NO_INFORMATION = "No Information";

const isPresent = (value?: string): boolean =>
  Boolean(value) && value !== NO_INFORMATION;

interface ExistingContact {
  contactId: string;
  fullName: string;
  email?: string;
}

interface ContactOption {
  value: string;
  label: string;
  description: string;
}

interface MatchResult {
  newContactNames: string[];
  newContactOptions: ContactOption[];
  preSelectedContactIds: string[];
}

export function matchExtractedContacts(
  extractedContacts: ExtractedContact[],
  existingContacts: ExistingContact[],
): MatchResult {
  const matched: string[] = [];
  const newNames: string[] = [];
  const newOptions: ContactOption[] = [];

  for (const extracted of extractedContacts) {
    const match = existingContacts.find(
      (c) => c.fullName.toLowerCase() === extracted.name?.toLowerCase(),
    );
    if (match) {
      matched.push(match.contactId);
    } else if (extracted.name) {
      const newId = `new_${extracted.name}`;
      newNames.push(extracted.name);
      newOptions.push({
        value: newId,
        label: extracted.name,
        description: [extracted.email, extracted.phone]
          .filter(isPresent)
          .join(" · "),
      });
      matched.push(newId);
    }
  }

  return {
    newContactNames: newNames,
    newContactOptions: newOptions,
    preSelectedContactIds: matched,
  };
}

export function formatList(items: string[]): string {
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(", ")}, and ${items[items.length - 1]}`;
}
